import { Select } from 'antd';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
  width: 100%;

  &.ant-select .ant-select-selector {
    align-items: center;
  }

  .ant-select-selection-item {
    display: flex;
    align-items: center;
  }
`;

export const AssetOption = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2px 0;
  line-height: 1.5;
`;

export const AssetOptionName = styled.span`
  font-size: 14px;
`;

export const AssetOptionMeta = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.secondaryTextColor ?? theme.gray ?? 'rgba(0, 0, 0, 0.6)'};
`;
